<template>
  <b-modal
    id="modal-scrollable"
    v-model="$store.state.someVariables.showPaseModal"
    no-close-on-backdrop
    title="Nuevo Pase"
    cancel-variant="outline-secondary"
    ok-only
    @hidden="reset"
  >
    <div class="mb-1">
      <small><b>Transferir del club : </b></small>
    </div>
    <div>
      <b-row v-for="item in listEquiposTransferir" :key="item.id">
        <b-col>
          <b-form-radio
            v-model="radioSelected"
            name="some-radios"
            :value="item"
            @change="changeRadio"
          >
            <small>
              {{ item.apodo }} {{ item.alias_equipo }} - {{ item.disciplina }}
              {{ item.categoria }}</small
            >
          </b-form-radio></b-col
        >
      </b-row>
    </div>
    <div class="mt-2">
      <b-form-checkbox v-model="checkOtra">
        <b>A otra Liga</b>
      </b-form-checkbox>
    </div>

    <template v-if="!checkOtra">
      <div class="mt-2">
        <small><b> Al club:</b> </small>
      </div>
      <v-select
        placeholder="Seleccione Categoria"
        :options="listCategoriasFilter"
        :clearable="false"
        style="width: 100%"
        @input="changeCategoriaAdmin"
        v-model="categoriaSeleccionada"
      />
      <v-select
        placeholder="Seleccione el Equipo"
        :options="listEquipos"
        :clearable="false"
        style="width: 100%; text-transform:capitalize"
        v-model="equipoSeleccionado"
        class="mt-2"
      />
      <b-form-input
        v-model="numCamiseta"
        placeholder="# camiseta"
        class="d-flex mt-2"
        type="number"
      />
    </template>
    <template #modal-footer>
      <div class="w-100">
        <template>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="float-right"
            @click="savePase"
          >
            Guardar
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="float-right mr-1"
            @click="onlyClose"
          >
            Cancelar
          </b-button>
        </template>

        <b-alert
          :show="dismissCountDown"
          v-height-fade.appear
          :variant="variante"
          style="position:absolute; bottom:55px;  width:92%; margin-left:-4px"
          @dismiss-count-down="countDownChanged"
        >
          <div
            :class="{
              'alert-body danger': variante == 'danger',
              'alert-body success': variante == 'success',
            }"
          >
            {{ messageError }}
          </div>
        </b-alert>
      </div>
    </template>
  </b-modal>
</template>
<script>
import {
  BRow,
  BCol,
  BFormRadio,
  BAlert,
  BButton,
  BFormInput,
  BFormCheckbox,
  //   BInputGroupText,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import vSelect from 'vue-select'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
  //   ESTADO_JUGADOR,
} from '../../utils/variables'

export default {
  components: {
    vSelect,
    BRow,
    BCol,
    BFormRadio,
    BAlert,
    BButton,
    BFormInput,
    BFormCheckbox,
  },
  directives: {
    Ripple,
    heightFade,
  },
  props: {
    listCategorias: Array,
    listEquiposTransferir: Array,
    player: Object,
  },
  setup(props, { emit }) {
    const categoriaSeleccionada = ref(null)
    const equipoSeleccionado = ref(null)
    const radioSelected = ref(null)
    const listEquipos = ref([])
    const listCategoriasFilter = ref([])
    const messageError = ref('')
    const variante = ref('danger')
    const dismissCountDown = ref(0)
    const dismissSecs = ref(3)
    const numCamiseta = ref(null)
    const hasError = ref(false)
    const checkOtra = ref(false)
    const { postApi } = apiCall()
    // const showLoading = ref(false)
    function reset() {
      categoriaSeleccionada.value = null
      equipoSeleccionado.value = null
      radioSelected.value = null
      numCamiseta.value = null
      listCategoriasFilter.value = []
      listEquipos.value = []
    }
    function onlyClose() {
      reset()
      store.commit('someVariables/UPDATE_SHOW_PASE_MODAL', false)
    }
    function showMessageAlert(type, mensaje) {
      variante.value = type
      hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function verifYError() {
      // console.log(categoriaSeleccionada.value)
      // console.log(radioSelected.value)
      let error = false
      // console.log(equipoSeleccionado.value)
      if (radioSelected.value === null) {
        error = true
        showMessageAlert('danger', 'Selecciona el equipo emisor del pase')
      } else if (categoriaSeleccionada.value === null) {
        error = true
        showMessageAlert('danger', 'Debes seleccionar el equipo destino')
      } else if (equipoSeleccionado.value === null) {
        error = true
        showMessageAlert('danger', 'Debes seleccionar el equipo destino')
      } else if (numCamiseta.value === null) {
        error = true
        showMessageAlert('danger', 'Debes ingresar el número de camiseta')
      }

      return error
    }
    function verifYErrorOtra() {
      // console.log(categoriaSeleccionada.value)
      // console.log(radioSelected.value)
      let error = false
      // console.log(equipoSeleccionado.value)
      if (radioSelected.value === null) {
        error = true
        showMessageAlert('danger', 'Selecciona el equipo emisor del pase')
      }
      return error
    }
    function changeCategoriaAdmin() {
      listEquipos.value = []
      //   equipoSeleccionado.value = {
      //     label: 'Seleccione Equipo',
      //     isInReview: false,
      //     value: null,
      //   }
      equipoSeleccionado.value = null
      // console.log(categoriaSeleccionada.value)
      const filtroCategoria = props.listCategorias.filter(
        // eslint-disable-next-line
        categoria => categoria.value === categoriaSeleccionada.value.value
      )
      const flitroUsar = filtroCategoria[0]
      //   const dataCategoriaUsar = flitroUsar.data_categoria
      flitroUsar.equipos.forEach(element => {
        const obj = {
          label: `${element.apodo} ${element.alias_equipo}`,
          value: element.id_equipo,
          //   id_disciplina: flitroUsar.id_disciplina,
          //   isOpen: true,
          //   validations: flitroUsar.validations,
          //   data_categoria: dataCategoriaUsar,
        }
        listEquipos.value.push(obj)
      })
    }

    function changeRadio() {
      // console.log(radioSelected.value)
      listCategoriasFilter.value = props.listCategorias.filter(
        // eslint-disable-next-line
        element =>
          // eslint-disable-next-line
          element.agrupacion_pase === radioSelected.value.agrupacion_pase
      )
    }
    // const listPlayersFilter = computed(() =>
    //   props.listCategorias.filter(
    //     element => element.agrupar == radioSelected.value.agrupar
    //   )
    // )

    async function savePase() {
      const path = 'ApiInscripciones/insertPase'

      if (!checkOtra.value) {
        if (!verifYError()) {
          // console.log(dataSend)
          const dataSend = {
            id_jugador: props.player.id_jugador,
            id_equipo_sale: radioSelected.value.id_equipo,
            id_agrupar_sale: radioSelected.value.agrupar,
            id_equipo_entra: equipoSeleccionado.value?.value || null,
            id_agrupar_entra: categoriaSeleccionada.value.agrupar,
            fecha_nac: props.player.fecha_nac,
            num_camiseta: numCamiseta.value,
            rol: USER().rol,
            tipo_jugador: props.player.tipoJugador,
            cat_sale: `${radioSelected.value.disciplina} ${radioSelected.value.categoria}`,
            cat_entra: `${categoriaSeleccionada.value.label}`,
            id_usuario: USER().id_usuario,
            tipo_pase: 'i',
            id_torneo:
              store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
          }
          const response = await postApi(URL, path, dataSend)
          // console.log(response)
          if (response.flag === 'si') {
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: 'PASE REGISTRADO con éxito',
                  icon: 'AlertCircleIcon',
                  variant: 'success',
                  solid: true,
                },
              },
              {
                position: 'bottom-center',
                // eslint-disable-next-line
              }
            )
            emit('initDataPase')
            store.commit('someVariables/UPDATE_SHOW_PASE_MODAL', false)
          } else {
            showMessageAlert('danger', response.mensaje)
          }
        }
      } else if (checkOtra.value) {
        if (!verifYErrorOtra()) {
          const dataSend = {
            id_jugador: props.player.id_jugador,
            id_equipo_sale: radioSelected.value.id_equipo,
            id_agrupar_sale: radioSelected.value.agrupar,
            id_equipo_entra: null,
            id_agrupar_entra: null,
            fecha_nac: props.player.fecha_nac,
            num_camiseta: null,
            rol: USER().rol,
            tipo_jugador: props.player.tipoJugador,
            cat_sale: `${radioSelected.value.disciplina} ${radioSelected.value.categoria}`,
            cat_entra: 'otra liga',
            id_usuario: USER().id_usuario,
            tipo_pase: 'e',
            id_torneo:
              store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
          }
          const response = await postApi(URL, path, dataSend)
          // console.log(response)
          if (response.flag === 'si') {
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: 'PASE REGISTRADO con éxito',
                  icon: 'AlertCircleIcon',
                  variant: 'success',
                  solid: true,
                },
              },
              {
                position: 'bottom-center',
                // eslint-disable-next-line
              }
            )
            emit('initDataPase')
            store.commit('someVariables/UPDATE_SHOW_PASE_MODAL', false)
          } else {
            showMessageAlert('danger', response.mensaje)
          }
        }
      }
    }
    return {
      reset,
      categoriaSeleccionada,
      equipoSeleccionado,
      changeCategoriaAdmin,
      listEquipos,
      radioSelected,
      messageError,
      variante,
      dismissCountDown,
      dismissSecs,
      countDownChanged,
      showMessageAlert,
      hasError,
      savePase,
      onlyClose,
      numCamiseta,
      changeRadio,
      listCategoriasFilter,
      checkOtra,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
